<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期间</label>
            <span class="weui-form-preview__value">{{initData.sm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.sm_seller}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.sm_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收余额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sm_end_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">预收余额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sm_end_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期收款（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sm_received}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收总额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sm_end}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>